import { clsx } from 'clsx'
import { type ChangeEvent, type FC, type InputHTMLAttributes } from 'react'

import './index.scss'

export interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  /** When set, the field renders the error border and shows this message below the input. */
  errorText?: string
}

export const TextInput: FC<TextInputProps> = ({ value, onChange, errorText, className, ...rest }) => (
  <div className="text-input-field">
    <input
      type="text"
      className={clsx('text-input', errorText && 'text-input--error', className)}
      value={value}
      onChange={onChange}
      aria-invalid={errorText ? true : undefined}
      {...rest}
    />
    {errorText && <span className="text-input__error">{errorText}</span>}
  </div>
)
